module.exports = __webpack_public_path__ + "static/media/Tam.175a98b2.png";